import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = ['La Guía Maestra de Alivio del Nervio Ciático (PDF de lectura rápida).', 'El Protocolo S.O.S de 8 minutos para ataques de dolor agudo.', 'El Mapa Visual de "Descompresión por Gravedad" paso a paso.', 'Guía Práctica de Higiene Postural: Cómo dormir y sentarte para prevenir recaídas.', 'Checklist de Recuperación: Lo que debes hacer (y evitar) en los primeros 7 días.'];
  return <section className="py-16 md:py-24 bg-cream" data-id="element-180">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-181">
        <FadeIn data-id="element-182">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-teal-900 mb-12 text-center" data-id="element-183">
            Lo que obtienes hoy
          </h2>
        </FadeIn>

        <div className="bg-white rounded-2xl shadow-xl border border-cream-200 overflow-hidden" data-id="element-184">
          <div className="p-8 md:p-12" data-id="element-185">
            <ul className="space-y-6" data-id="element-186">
              {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-187">
                  <li className="flex items-start gap-4" data-id="element-188">
                    <CheckCircle2 className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-189" />
                    <span className="text-gray-800 text-lg md:text-xl font-medium leading-relaxed" data-id="element-190">
                      {item}
                    </span>
                  </li>
                </FadeIn>)}
            </ul>
          </div>
          <div className="bg-teal-50 p-6 border-t border-teal-100 text-center" data-id="element-191">
            <p className="text-teal-800 font-semibold" data-id="element-192">
              Todo en formato digital para acceso inmediato.
            </p>
          </div>
        </div>
      </div>
    </section>;
}